import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '../../../theme';

const Image = styled.img`
  height: ${(props) => props.height}em;
  display: inline !important;

  ${media.md`
    margin: ${(props) => props.margin}px;
  `}

  @media (max-width: 991px) {
    max-width: inherit;
  }
`;

const Epic = ({ height, margin }) => {
  const renderEpic = `${process.env.PUBLIC_URL}/${'Epic.png'}`;

  return (
    <Image
      id="Epic"
      src={renderEpic}
      alt="Within Health Epic"
      height={height}
      margin={margin}
    />
  );
};

Epic.propTypes = {
  onWhite: PropTypes.bool,
  height: PropTypes.number,
  margin: PropTypes.number,
  display: PropTypes.string,
};

Epic.defaultProps = {
  onWhite: true,
  height: 10,
  margin: 2,
};

export default Epic;
